module.exports = __webpack_public_path__ + "static/media/phila_green.5a4889c2.webp";